<template>
  <transition
      tag="div"
      class="flex flex-wrap"
      enter-active-class="animate-pop-in"
      leave-active-class="animate-pop-out"
  >
    <slot />
  </transition>

</template>

<script setup>

</script>

<style scoped>

</style>